import { render, staticRenderFns } from "./ghCodeEditor.vue?vue&type=template&id=bc26e30e&scoped=true&"
import script from "./ghCodeEditor.vue?vue&type=script&lang=js&"
export * from "./ghCodeEditor.vue?vue&type=script&lang=js&"
import style0 from "./ghCodeEditor.vue?vue&type=style&index=0&id=bc26e30e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc26e30e",
  null
  
)

export default component.exports